import { Component, OnDestroy, OnInit } from '@angular/core';
import {
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
} from '@angular/forms';
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
	MAT_MOMENT_DATE_ADAPTER_OPTIONS,
	MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { ActivatedRoute, Router } from '@angular/router';

import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import moment from 'moment';

import { AddressConstants } from '../../../../modules/address/address.constants';
import { AddressService } from '../../../../modules/address/address.service';
import { BeneficiariesService } from '../../../../modules/beneficiaries/beneficiaries.service';
import { Gender } from '../../../../shared/enums/gender.enum';
import { MaritalStatus } from '../../../../shared/enums/marital-status.enum';
import { TypeKinship } from '../../../../shared/enums/type-kinship.enum';
import { MARITAL_STATUS } from '../../../../shared/models/marital-status';
import { DataTypeUtils } from '../../../../utils/data-type.util';
import { PT_BR_DATE_FORMATS } from '../../../../utils/date-formats.utils';
import { PhoneUtils } from '../../../../utils/phone-utils';
import { TitularRegistration } from '../../models/beneficiaries.model';
import {
	GroupsListSummary,
	MessageResponse,
} from '../../models/organizations.model';
import { OrganizationsLegacyService } from '../../organizations-legacy.service';
import {
	fetchAddressByCEPStart,
	fetchAuxUFCitiesClear,
	fetchUFCitiesClear,
	fetchEmailAvailabilityStart,
	fetchOrgPositionsStart,
	editBeneficiaryClearCompleAct,
	restoreFormReset,
} from '../../state/organizations.actions';
import {
	selectAddressResult,
	selectAuxCities,
	selectCities,
	selectEmailAvailability,
	selectPositions,
} from '../../state/organizations.selector';
import { OrgGroupModalComponent } from '../user-registration/org-group-modal/org-group-modal.component';
import { OrgListModalComponent } from '../user-registration/org-list-modal/org-list-modal.component';

@Component({
	providers: [
		{ provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
		{
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
			provide: DateAdapter,
			useClass: MomentDateAdapter,
		},
		{ provide: MAT_DATE_FORMATS, useValue: PT_BR_DATE_FORMATS },
	],
	selector: 'app-beneficiary-edit',
	styleUrls: ['./beneficiary-edit.component.scss'],
	templateUrl: './beneficiary-edit.component.html',
})
export class BeneficiaryEditComponent implements OnInit, OnDestroy {
	addForm: UntypedFormGroup;
	auxCities: string[] = [];
	auxStateForm: boolean = true;
	auxStateForm2: boolean = true;

	beneficiaryId: string = '';
	beneficiaryType: string = '';

	cepPattern = '[0-9]{8}';
	cfgForm: UntypedFormGroup;
	cities: string[] = [];

	cpfPattern = '[0-9]{11}';
	dateFilter = (dateToFilter: Date | null): boolean => {
		const date = new Date(dateToFilter ?? '');
		const year = date.getFullYear();

		return year > 2015 && year < 2032;
	};
	dialogRef!: MatDialogRef<OrgGroupModalComponent | OrgListModalComponent>;
	editingEmail: string = '';
	editingPosition!: any;
	genders: Gender[] = Object.values(Gender);

	groups: GroupsListSummary[] = [];
	inputId: string = String(Math.random());
	isDisabledSaveButton = false;

	isLoading: boolean = false;
	isLoadingCities = false;

	isLoadingWorkCities = false;

	maritalStatusList = MARITAL_STATUS;
	organizationId: string = '';
	phoneMask = (value: string): string => {
		this.usrForm.get('phone')?.updateValueAndValidity();

		return value ? PhoneUtils.phoneMask(value) : '';
	};
	positions: any[] = [];
	prfForm: UntypedFormGroup;
	prsForm: UntypedFormGroup;
	regStep = 1;
	typeKinship: TypeKinship = TypeKinship.TITULAR;
	uf = AddressConstants.ufLabels;

	usrForm: UntypedFormGroup;
	wAddForm: UntypedFormGroup;

	private onSubmitSubscription$: Subscription = new Subscription();

	private searchSubscription$: Subscription = new Subscription();

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly activatedRoute: ActivatedRoute,
		private readonly beneficiariesService: BeneficiariesService,
		private readonly fb: UntypedFormBuilder,
		private readonly organizationsService: OrganizationsLegacyService,
		private readonly router: Router,
		private readonly store: Store,
		private readonly addressService: AddressService,
	) {
		this.usrForm = this.fb.group({
			cpf: [
				{ disabled: true, value: null },
				[Validators.required, Validators.pattern(this.cpfPattern)],
			],
			email: [{ disabled: true, value: null }, [Validators.email]],
			name: [null, [Validators.required]],
			phone: [null, [Validators.pattern(DataTypeUtils.phone.pattern)]],
			socialName: [null],
		});
		this.prsForm = this.fb.group({
			birthday: [null, [Validators.required]],
			gender: [null],
			marital_status: [null],
			marriageDate: [null],
			mothers_name: [null],
		});
		this.addForm = this.fb.group({
			city: [null],
			complement: [null],
			neighborhood: [null],
			number: [null],
			postal_code: [null, [Validators.pattern(this.cepPattern)]],
			state: [null],
			street: [null],
		});
		this.addForm.get('state')!.disable();
		this.addForm.get('city')!.disable();
		this.prfForm = this.fb.group({
			admission_date: [null],
			plan_inclusion_date: [null],
			position_id: [null],
			registration: [null],
			wage: [null],
		});
		this.wAddForm = this.fb.group({
			city: [null],
			state: [null],
		});
		this.cfgForm = this.fb.group({
			active: [null],
			inactived_at: [null],
			is_deleted: [false],
			stay_date: [null],
		});
	}

	checkBeneficiaryType(): void {
		if (
			this.beneficiaryType === 'inativo' ||
			this.beneficiaryType === 'aposentado'
		) {
			this.usrForm.disable();
			this.prsForm.disable();
			this.addForm.disable();
			this.prfForm.disable();
			this.wAddForm.disable();
			this.cfgForm.controls.active.disable();
			this.cfgForm.controls.inactived_at.disable();
			this.cfgForm.controls.stay_date.disable();
		}
	}

	disabledSaveBtn(): boolean {
		const cfgF = this.cfgForm.value;

		if (!cfgF.active && this.beneficiaryType === 'ativo') {
			return (
				this.cfgForm.controls.inactived_at.invalid || cfgF.inactived_at === null
			);
		}

		return !!(
			!this.usrForm.getRawValue().cpf ||
			this.usrForm.get('name')?.invalid ||
			this.prsForm.get('birthday')?.invalid
		);
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
		this.searchSubscription$.unsubscribe();
		this.onSubmitSubscription$.unsubscribe();
		this.store.dispatch(editBeneficiaryClearCompleAct());
		this.store.dispatch(fetchUFCitiesClear());
		this.store.dispatch(fetchAuxUFCitiesClear());
		this.store.dispatch(restoreFormReset());
	}

	ngOnInit(): void {
		this.activatedRoute.params.subscribe(({ id, bId }) => {
			this.organizationId = id;
			this.beneficiaryId = bId;
			this.searchPositions(id);

			this.searchSubscription$ = this.beneficiariesService
				.searchBeneficiary({
					beneficiaryId: this.beneficiaryId,
					organizationId: this.organizationId,
				})
				.subscribe(
					(beneficiary: TitularRegistration) => {
						if (beneficiary) {
							this.isDisabledSaveButton = true;
							this.editingEmail = beneficiary.user!.email;
							if (beneficiary.position.id) {
								this.editingPosition = beneficiary.position.id;
							}

							this.setBeneficiary(beneficiary);

							this.typeKinship = beneficiary.typeKinship;

							this.auxStateForm = false;
							this.auxStateForm2 = false;

							this.checkBeneficiaryType();

							this.store
								.select(selectCities)
								.pipe(takeUntil(this.unsubscribe$))
								.subscribe((cities) => {
									if (cities.length) {
										this.addForm.get('city')!.enable();
									}
									this.cities = cities;
								});
							this.store
								.select(selectAuxCities)
								.pipe(takeUntil(this.unsubscribe$))
								.subscribe((cities) => {
									if (cities.length) {
										this.wAddForm.get('city')!.enable();
										this.auxCities = cities;
										this.auxStateForm2 = true;
									}
								});
							this.isLoading = false;
						}
					},
					(error: any) => {
						this.organizationsService.showSnack(error.error?.message, 'error');
					},
				);
		});
	}

	onActivenessChange(active: boolean): void {
		if (active) {
			this.cfgForm.get('inactived_at')!.setValue(null);
			this.cfgForm.get('is_deleted')!.setValue(null);
		}

		const validators = active ? [] : [Validators.required];
		this.cfgForm.get('inactived_at')!.setValidators(validators);
		this.cfgForm.get('inactived_at')!.updateValueAndValidity();
	}

	onCancelEdit(): void {
		if (this.organizationId && this.beneficiaryId) {
			this.router.navigate([
				'organizacoes',
				this.organizationId,
				'beneficiarios',
				this.beneficiaryType,
				this.beneficiaryId,
			]);
		}
	}

	onCepBlur(): void {
		const postalCodeControl = this.addForm.get('postal_code');

		if (postalCodeControl!.valid && postalCodeControl!.value) {
			const cep: string = postalCodeControl!.value;
			this.store.dispatch(fetchAddressByCEPStart({ cep }));
			this.store.select(selectAddressResult).subscribe((result) => {
				if (result?.error) {
					this.store.dispatch(fetchUFCitiesClear());
					this.auxStateForm = true;
					this.addForm.get('state')!.setValue(null);
					this.addForm.get('city')!.setValue(null);
					this.addForm.get('state')!.enable();
				} else {
					this.auxStateForm = false;
					this.addForm.get('street')!.setValue(result?.street);
					this.addForm.get('neighborhood')!.setValue(result?.neighborhood);
					this.addForm.get('state')!.setValue(result?.state);
					this.addForm.get('city')!.setValue(result?.city);
					this.addForm.get('state')!.disable();
					this.addForm.get('city')!.disable();
				}
			});
		}
	}

	onEmailBlur(): void {
		if (this.usrForm.get('email')!.valid) {
			const email: string = this.usrForm.get('email')!.value;

			if (email === this.editingEmail) {
				this.usrForm.get('email')!.updateValueAndValidity();
			} else {
				this.store.dispatch(fetchEmailAvailabilityStart({ email }));
				this.store
					.select(selectEmailAvailability)
					.pipe(takeUntil(this.unsubscribe$))
					.subscribe((result) => {
						if (result) {
							this.usrForm.get('email')!.updateValueAndValidity();
						} else {
							this.usrForm.get('email')!.setErrors({ minlength: true });
						}
					});
			}
		}
	}

	onMaritalStatusChange(maritalStatus: string): void {
		if (maritalStatus === MaritalStatus.CASADO) {
			this.prsForm.get('marriageDate')?.enable();
		} else {
			this.prsForm.get('marriageDate')?.disable();
			this.prsForm.get('marriageDate')?.setValue(null);
		}
	}

	onSubmit(): void {
		this.isLoading = true;

		if (
			this.beneficiaryType === 'inativo' ||
			this.beneficiaryType === 'aposentado'
		) {
			this.updateInactiveOrRetired();
		} else {
			const request = this.processForm();

			if (request) {
				this.onSubmitSubscription$ = this.beneficiariesService
					.updateActive({
						beneficiaryId: this.beneficiaryId,
						dto: request,
						organizationId: this.organizationId,
					})
					.subscribe(
						async (response: MessageResponse) => {
							this.isLoading = false;
							this.organizationsService.showSnack(
								response?.message,
								response?.type,
							);
							await this.router.navigate([
								'organizacoes',
								this.organizationId,
								'beneficiarios',
								this.beneficiaryId,
							]);
						},
						(error) => {
							this.isLoading = false;
							this.organizationsService.showSnack(
								error.error?.message,
								'error',
							);
						},
					);
			}
		}
	}

	onUfChange(id: number, group?: 'address' | 'work'): void {
		const workCityInput = this.wAddForm.get('city');
		const cityInput = this.addForm.get('city');

		if (group === 'address') {
			cityInput!.setValue(null);
			cityInput!.disable();
			this.isLoadingCities = true;
		} else {
			workCityInput!.setValue(null);
			workCityInput!.disable();
			this.isLoadingWorkCities = true;
		}

		this.addressService.getCitiesByUfId(id).subscribe({
			error: () => {
				this.isLoadingWorkCities = false;
				this.isLoadingCities = false;

				if (group === 'address') {
					this.auxStateForm = false;
				} else {
					this.auxStateForm2 = false;
				}
			},
			next: (response) => {
				const cities = this.addressService.organizeCitiesByUfId(id, response);

				if (group === 'address') {
					this.cities = cities;
					this.auxStateForm = true;
				} else {
					this.auxCities = cities;
					this.auxStateForm2 = true;
				}

				this.isLoadingWorkCities = false;
				this.isLoadingCities = false;
			},
		});

		workCityInput!.enable();
		cityInput!.enable();
	}

	processForm(): any {
		// if (this.prsForm.invalid || this.addForm.invalid || this.wAddForm.invalid || this.prfForm.invalid) {
		//   return null;
		// }
		this.addForm.get('state')!.enable();
		this.addForm.get('city')!.enable();
		this.wAddForm.get('city')!.enable();
		const user = this.usrForm.value;

		user.email = this.normalizeEmptyToNull(user.email);
		user.socialName = this.normalizeEmptyToNull(user.socialName);

		const prs = this.prsForm.value;
		const cfg = this.cfgForm.value;
		const add = this.addForm.value;
		const wAdd = this.wAddForm.value;
		const prf = this.prfForm.value;
		prf.wage = prf?.wage ? prf.wage.replace('.', '').replace(',', '.') : null;
		this.addForm.get('state')!.disable();
		this.addForm.get('city')!.disable();
		this.wAddForm.get('city')!.disable();
		const request: any = {
			id: this.beneficiaryId,
			...prs,
			...cfg,
			address: add,
			city_work: wAdd.city,
			professional_data: prf,
			state_work: wAdd.state,
			user,
		};
		request.inactived_at = request.inactived_at
			? moment(request.inactived_at).format('YYYY-MM-DD hh:mm:ssZZ')
			: null;
		request.birthday = moment(request.birthday).format('YYYY-MM-DD hh:mm:ssZZ');
		request.marriageDate = request.marriageDate
			? moment(request.marriageDate).format('YYYY-MM-DD hh:mm:ssZZ')
			: null;
		request.professional_data.admission_date =
			request.professional_data.admission_date &&
			moment(request.professional_data.admission_date).isValid()
				? moment(request.professional_data.admission_date).format(
						'YYYY-MM-DD hh:mm:ssZZ',
					)
				: null;
		request.professional_data.plan_inclusion_date =
			request.professional_data.plan_inclusion_date &&
			moment(request.professional_data.plan_inclusion_date).isValid()
				? moment(request.professional_data.plan_inclusion_date).format(
						'YYYY-MM-DD hh:mm:ssZZ',
					)
				: null;
		request.professional_data.wage = request.professional_data.wage
			? Number(String(request.professional_data.wage).replace(',', '.'))
			: null;

		return request;
	}

	processLabelCase(label: string) {
		if (label) {
			return label.replace(/\w\S*/g, (txt: string) => {
				return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
			});
		} else {
			return '';
		}
	}

	searchPositions(id: string): void {
		this.store.dispatch(fetchOrgPositionsStart({ id }));

		this.store
			.select(selectPositions)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((positions) => {
				if (positions) {
					this.positions = positions.map((position) => {
						return {
							id: position.id,
							city: position.city,
							name: position.name,
							state: position.state,
						};
					});
				}
			});
	}

	setBeneficiary(beneficiary: TitularRegistration): void {
		const validators = beneficiary.active ? [] : [Validators.required];
		this.cfgForm = this.fb.group({
			active: [beneficiary.active],
			inactived_at: [beneficiary.inactived_at ?? null, validators],
			is_deleted: [beneficiary.is_deleted ?? false],
			stay_date: [beneficiary.stay_date ?? null],
		});
		this.usrForm = this.fb.group({
			cpf: [
				{ disabled: true, value: beneficiary.user!.cpf },
				[Validators.required, Validators.pattern(this.cpfPattern)],
			],
			email: [beneficiary.user!.email, [Validators.email]],
			name: [beneficiary.user!.name, [Validators.required]],
			phone: [
				beneficiary.user!.phone,
				[Validators.pattern(DataTypeUtils.phone.pattern)],
			],
			socialName: [beneficiary.user!.socialName ?? null],
		});
		this.prsForm = this.fb.group({
			active: [beneficiary.active],
			birthday: [moment(beneficiary.birthday), [Validators.required]],
			gender: [beneficiary.gender?.toUpperCase()],
			marital_status: [beneficiary.marital_status],
			marriageDate:
				beneficiary.marital_status === MaritalStatus.CASADO
					? [
							beneficiary.marriageDate
								? moment(beneficiary.marriageDate)
								: null,
							[],
						]
					: [{ disabled: true, value: null }],
			mothers_name: [beneficiary.mothers_name],
		});
		this.addForm = this.fb.group({
			city: [{ disabled: true, value: beneficiary.address.city }],
			complement: [beneficiary.address.complement],
			neighborhood: [beneficiary.address.neighborhood],
			number: [beneficiary.address.number],
			postal_code: [
				beneficiary.address.postal_code,
				[Validators.pattern(this.cepPattern)],
			],
			state: [beneficiary.address.state],
			street: [beneficiary.address.street],
		});
		this.prfForm = this.fb.group({
			admission_date: [moment(beneficiary.professional_data.admission_date)],
			plan_inclusion_date: [
				moment(beneficiary.professional_data.plan_inclusion_date),
			],
			position_id: [beneficiary.position.id ?? null],
			registration: [beneficiary.professional_data.registration],
			wage: [
				beneficiary.professional_data.wage
					? beneficiary.professional_data.wage.replace('.', ',')
					: null,
			],
		});
		this.wAddForm = this.fb.group({
			city: [{ disabled: true, value: beneficiary.city_work }],
			state: [beneficiary.state_work],
		});
		this.typeKinship = beneficiary.typeKinship;
		this.onMaritalStatusChange(beneficiary.marital_status);
	}

	updateInactiveOrRetired(): void {
		const cpf = this.usrForm.controls.cpf.value;
		const is_deleted = this.cfgForm.controls.is_deleted.value;
		const dto = {
			cpf,
			is_deleted,
		};

		this.onSubmitSubscription$ = this.beneficiariesService
			.updateInactiveOrRetired({
				beneficiaryId: this.beneficiaryId,
				beneficiaryType: this.beneficiaryType,
				dto,
				organizationId: this.organizationId,
			})
			.subscribe(
				async (response: MessageResponse) => {
					this.isLoading = false;
					this.organizationsService.showSnack(
						response?.message,
						response?.type,
					);
					await this.router.navigate([
						'organizacoes',
						this.organizationId,
						'beneficiarios',
						this.beneficiaryType,
						this.beneficiaryId,
					]);
				},
				(error) => {
					this.isLoading = false;
					this.organizationsService.showSnack(error.error?.message, 'error');
				},
			);
	}

	private normalizeEmptyToNull(value: string | null): string | null {
		return value && value.trim() !== '' ? value : null;
	}
}
